<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="row">
				<div class="col-md-2">
					ID
					<a-input-search :value="filters.id" @change="handleIdChange" @search="searchById" style="width: 100%" placeholder="ID" />
				</div>
				<div class="col-md-2">
					Estatus
					<a-select :value="filters.status" @change="handleStatusChange" style="width: 100%">
						<a-select-option value="0"> Solicitudes </a-select-option>
						<a-select-option value="5"> Enviadas </a-select-option>
						<a-select-option value="2"> Autorizado / En preparación </a-select-option>
						<a-select-option value="3"> En reparto </a-select-option>
						<a-select-option value="4"> Entregado </a-select-option>
					</a-select>
				</div>
				<div class="col-md-3">
					Cliente
					<a-select showSearch :value="filters.customer_id" @change="handleCustomerChange" style="width: 100%" :filterOption="filterOption">
						<a-select-option value=""> Todos </a-select-option>
						<a-select-option v-for="customer in sortedCustomers" :key="customer.id" :value="customer.id">
							{{ customer.full_name }}
						</a-select-option>
					</a-select>
				</div>
				<div class="col-md-2">
					¿Pagado?
					<a-select :value="filters.paid" @change="handlePaidChange" style="width: 100%">
						<a-select-option value=""> Todos </a-select-option>
						<a-select-option value="1"> Sí </a-select-option>
						<a-select-option value="0"> No </a-select-option>
					</a-select>
				</div>
				<div class="col-md-3 text-right pt20">
					<a-button class="btn btn-warning" icon="file-text" @click="logProductSummary">Resumen</a-button>
					<a-button class="btn btn-info ml7" icon="plus" @click="onAddRecord">Nueva cotización</a-button>
					<a-button class="btn btn-success ml7" icon="reload" @click="initModule" />
				</div>
			</div>
			<div class="row pt10">
				<div class="col-md-12">
					<a-table
						:columns="columns"
						:dataSource="searchText == '' ? impressmentList : impressmentListFiltered"
						rowKey="id"
						bordered
						:scroll="{ x: '1000px' }"
						:pagination="pagination"
						:loading="spinnerLoader"
						@change="initModule"
					>
						<div slot="fullName" slot-scope="record">
							<div style="font-size: 25px">#{{ record.id }}</div>
							<div>{{ record.fullName }}</div>
							<div>{{ moment(record.created_at).format('DD-MM-YYYY HH:mm') }} hrs.</div>
							<div>
								<small class="pointer" @click="getLogs(record.id)"><b>- LOGS -</b></small>
							</div>
						</div>
						<div slot="customer_name" slot-scope="record" class="text-left">
							<div class="text-uppercase"><i class="fa fa-user"></i> {{ record.customer_name }}</div>
							<div class="text-uppercase">
								<i class="fa fa-building"></i> {{ record.description || '- no definido -' }}
								<div><i class="fa fa-map"></i> <a :href="record.link" target="_blank" rel="noopener noreferrer">Ubicación Maps</a></div>
							</div>
							<hr class="m0" />
							<div v-if="evidenceMap[`E_${filters.status}`]">
								<small @click="openEvidenceModal(record.id)" style="margin-left: 15px" class="pointer"><b>Ver evidencias</b></small>
							</div>
						</div>
						<div slot="description" slot-scope="record" class="text-left">
							<div v-for="(element, index) in record.elements" :key="index">
								{{ `${element.quantity}` }}x {{ element.description }} {{ element.price ? ` ${numeral(element.price).format('$0,0.00')}` : '' }}
								<div style="font-size: 12px" class="pointer">
									<b @click="copySKU(element.sku)">SKU: {{ element.sku }}</b>
								</div>
							</div>
						</div>
						<div slot="total" slot-scope="record" class="text-right">
							{{ numeral(getTotalImpressment(record.id)).format('$0,0.00') }}
							<div v-if="record.type_of_sale">
								<b>{{ record.type_of_sale == 'pull' ? 'Solicitud de cliente' : 'Fuerza de ventas' }}</b>
							</div>
							<div v-if="record.payment_method == 'NEXT'">
								<a-tag color="purple">ENTREGA: {{ moment(record.credit_payment_date).format('DD-MM-YYYY') }}</a-tag>
							</div>
						</div>
						<div slot="action" slot-scope="record">
							<a-tooltip placement="top" v-if="record.status == 5">
								<template slot="title">
									<span>Editar cotización</span>
								</template>
								<button class="btn btn-warning ant-btn-sm ant-btn-icon-only ml7" @click="changeStatus(record.id, 0)">
									<a-icon type="left" />
								</button>
							</a-tooltip>
							<a-tooltip placement="top" v-if="record.status == 0 && getAllowed.includes(Number(filters.status))">
								<template slot="title">
									<span>Editar</span>
								</template>
								<button class="btn btn-info ant-btn-sm ant-btn-icon-only ml7" @click="onEditRecord(record.id)">
									<a-icon type="edit" />
								</button>
							</a-tooltip>
							<a-tooltip placement="top" v-if="record.status == 5 && getAllowed.includes(Number(filters.status))">
								<template slot="title">
									<span>Enviar por whatsapp</span>
								</template>
								<button class="btn btn-info ant-btn-sm ant-btn-icon-only ml7" @click="sendQuotation(record.id, 'whatsapp')">
									<a-icon type="message" />
								</button>
							</a-tooltip>
							<a-tooltip placement="top" v-if="getAllowed.includes(Number(filters.status))">
								<template slot="title">
									<span>Eliminar</span>
								</template>
								<button class="btn btn-danger ant-btn-sm ant-btn-icon-only ml7" @click="onCancelRecord(record.id)">
									<a-icon type="delete" />
								</button>
							</a-tooltip>
							<a-tooltip placement="top" v-if="[2, 3, 4].includes(record.status) && !record.pos_id">
								<template slot="title">
									<span>Cobrar</span>
								</template>
								<button class="btn btn-success ant-btn-sm ant-btn-icon-only ml7" @click="setTicket(record.id)">
									<a-icon type="dollar" />
								</button>
							</a-tooltip>
							<a-tooltip placement="top">
								<template slot="title">
									<span>Imprimir</span>
								</template>
								<button class="btn btn-warning ant-btn-sm ant-btn-icon-only ml7" @click="printQuotation(record.id)">
									<a-icon type="printer" />
								</button>
							</a-tooltip>
							<a-tooltip placement="top" v-if="record.status == 5 && getAllowed.includes(Number(filters.status))">
								<template slot="title">
									<span>Continuar proceso</span>
								</template>
								<button class="btn btn-info ant-btn-sm ant-btn-icon-only ml7" @click="confirmQuote(record.id)">
									<a-icon type="right" />
								</button>
							</a-tooltip>
							<a-tooltip placement="top" v-if="[2, 3].includes(record.status) && getAllowed.includes(Number(filters.status))">
								<template slot="title">
									<span>Continuar proceso</span>
								</template>
								<button class="btn btn-info ant-btn-sm ant-btn-icon-only ml7" @click="changeStatus(record.id, record.status)">
									<a-icon type="right" />
								</button>
							</a-tooltip>
							<div v-if="record.pos_id">
								<small>Ticket #{{ record.pos_id }}</small>
							</div>
						</div>
					</a-table>
				</div>
			</div>
		</a-spin>
		<a-modal :visible="modalQuotationView" title="Detalle de cotización" :closable="true" @cancel="closeQuotationModal" width="80%" v-if="modalQuotationView">
			<template slot="footer">
				<a-button key="back" @click="closeQuotationModal"> Cerrar </a-button>
			</template>
			<div class="col-md-12 pt10">
				<object :data="quotationBase64" type="application/pdf" width="100%" height="600px"></object>
			</div>
		</a-modal>
		<a-modal width="50%" :visible="modalQuotationFiles" :title="`Registro de evidencias - ${modalTitle}`" :closable="true" @cancel="closeQuotationFilesModal(false)">
			<template slot="footer">
				<a-button key="back" @click="closeQuotationFilesModal(false)" :loading="false"> Cancelar </a-button>
			</template>
			<impressmentFiles :id="impressment_id" :status="filters.status" @close="closeQuotationFilesModal(true)" />
		</a-modal>
		<a-modal
			width="50%"
			:visible="evidencesModalShow"
			title="Registro de evidencias"
			:footer="null"
			:closable="true"
			@cancel="
				evidencesModal = []
				evidencesModalShow = false
			"
		>
			<div v-for="(text, key) in evidenceMap" :key="key">
				<h5 class="text-muted">{{ evidenceMap[key].at(-1) }}</h5>
				<div class="row" v-if="evidencesModal[key]">
					<div class="col-md-3" v-for="(img, index) in evidencesModal[key]" :key="index">
						<img :src="img.url" class="img-fluid" />
					</div>
				</div>
				<div class="row" v-else>
					<div class="col-md-12">Sin evidencia</div>
				</div>
				<div class="row">
					<div class="col-md-12"><hr /></div>
				</div>
			</div>
		</a-modal>
		<a-modal width="30%" :visible="logsView" title="LOGS" :footer="null" :closable="true" @cancel="logsView = false">
			<div>
				<span v-for="(element, index) in logs" :key="index"
					>{{ moment(element.created_at).format('DD-MM-YYYY HH:mm') }} hrs. - {{ element.action }}<br />
					{{ element.fullName }}
					<hr
				/></span>
			</div>
		</a-modal>
		<a-modal width="60%" :visible="summaryModalView" title="Resumen de Productos" :closable="true" @cancel="summaryModalView = false" :bodyStyle="{ paddingTop: 0 }">
			<template slot="footer">
				<a-button key="print" type="primary" icon="printer" @click="printSummary"> Imprimir </a-button>
				<a-button key="back" @click="summaryModalView = false"> Cerrar </a-button>
			</template>
			<a-tabs default-active-key="1" v-if="productSummaryList.length">
				<a-tab-pane key="1" tab="General">
					<table class="table table-bordered table-striped table-sm">
						<thead>
							<tr>
								<th>SKU</th>
								<th>Descripción</th>
								<th class="text-right">Cantidad</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in productSummaryList" :key="index">
								<td>
									<small
										><b>{{ item.sku }}</b></small
									>
								</td>
								<td>
									<small>{{ item.description }}</small>
								</td>
								<td class="text-right">{{ item.totalQuantity }}</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td colspan="2" class="text-right"><strong>Total de artículos:</strong></td>
								<td class="text-right">
									<strong>{{ totalSummaryItems }}</strong>
								</td>
							</tr>
						</tfoot>
					</table>
				</a-tab-pane>
				<a-tab-pane key="2" tab="Por producto agrupado">
					<table class="table table-bordered table-striped table-sm">
						<thead>
							<tr>
								<th>Descripción</th>
								<th class="text-right">Cantidad Total</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in groupedProductSummaryList" :key="index">
								<td>
									<small>{{ item.description }}</small>
								</td>
								<td class="text-right">{{ item.totalQuantity }}</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td class="text-right"><strong>Total de artículos:</strong></td>
								<td class="text-right">
									<strong>{{ totalSummaryItems }}</strong>
								</td>
							</tr>
						</tfoot>
					</table>
				</a-tab-pane>
			</a-tabs>
			<div v-else class="text-center pt10 pb10">No hay productos para mostrar.</div>
		</a-modal>
	</div>
</template>

<script>
//
import Vue from 'vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import Swal from 'sweetalert2'
import _ from 'lodash'
import numeral from 'numeral'
import { mask } from 'vue-the-mask'
import utilities from '@/services/utilities'
import impressmentFiles from '@/components/impressmentFiles'
import copy from 'copy-to-clipboard'

export default {
	name: 'ImpressmentView',
	components: {
		impressmentFiles,
	},
	directives: {
		mask,
	},
	computed: {
		...mapGetters('impressment', ['spinnerLoader', 'spinnerLoaderLabel', 'impressmentList', 'filters']),
		...mapGetters('customers', ['customersList']),
		...mapGetters('user', ['user']),
		userPermition() {
			// zem - 17
			// ismael - 1
			let allowedUserPermition = [1, 17]
			return !!allowedUserPermition.includes(this.user.user_id)
		},
		getImpressmentElements() {
			return this.actualRecord.impressmentElements.map((e, index) => {
				return {
					...e,
					index: index + 1,
				}
			})
		},
		getAllowed() {
			//
			if (this.user.user_id == 1) {
				return [0, 1, 2, 3, 4, 5]
			}
			return JSON.parse(utilities.objectValidate(this.user, 'impressment_allowed', '[]'))
		},
		sortedCustomers() {
			let customers = _.cloneDeep(this.customersList)
			return customers
				.map((c) => {
					if (c.full_name) {
						c.full_name = c.full_name.toUpperCase()
					}
					return c
				})
				.sort((a, b) => {
					const nameA = a.full_name || ''
					const nameB = b.full_name || ''
					return nameA.localeCompare(nameB)
				})
		},
	},
	data() {
		return {
			searchText: '',
			summaryModalView: false,
			productSummaryList: [],
			groupedProductSummaryList: [],
			productSummary: [],
			totalSummaryItems: 0,
			modalTitle: '',
			impressment_id: '',
			impressmentListFiltered: [],
			evidencesModal: [],
			modalQuotationView: false,
			modalQuotationFiles: false,
			evidencesModalShow: false,
			quotationBase64: '',
			evidenceMap: {
				E_2: ['Evidencia autorización'],
				E_3: ['Evidencia autorización', 'Evidencia reparto'],
				E_4: ['Evidencia autorización', 'Evidencia reparto', 'Evidencia entrega'],
			},
			logs: [],
			logsView: false,
			columns: [
				{
					title: 'Solicitante',
					scopedSlots: { customRender: 'fullName' },
					align: 'center',
					width: '15%',
				},
				{
					title: 'Cliente/Dirección',
					scopedSlots: { customRender: 'customer_name' },
					width: '15%',
				},
				{
					title: 'Solicitud',
					scopedSlots: { customRender: 'description' },
					align: 'center',
					width: '40%',
				},
				{
					title: 'Total',
					scopedSlots: { customRender: 'total' },
					align: 'center',
					width: '10%',
				},
				{
					title: 'Acciones',
					scopedSlots: { customRender: 'action' },
					align: 'center',
					width: '15%',
				},
			],
			modalView: false,
			actualRecord: {},
			selectedRowKeys: [],
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
			},
		}
	},
	mounted() {
		this.initModule()
		if (!this.customersList.length) {
			this.getCustomers()
		}
	},
	methods: {
		moment,
		numeral,
		getTotalImpressment(id) {
			let theImpressmentElements = (this.searchText == '' ? this.impressmentList : this.impressmentListFiltered).find((e) => e.id == id).elements
			return theImpressmentElements.reduce((previousValue, currentValue) => {
				return previousValue + currentValue.price * currentValue.quantity
			}, 0)
		},
		copySKU(sku) {
			copy(sku)
			Vue.prototype.$notification.success({
				message: 'Cotizaciones',
				description: `SKU ${sku} copiado`,
			})
		},
		getLogs(id) {
			// console.log('getLogs', id)
			this.$store.dispatch('impressment/GET_LOGS', id).then((response) => {
				this.logs = _.cloneDeep(response.data)
				this.logsView = true
			})
		},
		openEvidenceModal(id) {
			this.evidencesModal = _.cloneDeep(
				utilities.objectValidate(
					this.impressmentList.find((e) => e.id == id),
					['evidences'],
					[],
				),
			)

			this.evidencesModalShow = true
		},
		changeStatus(id, status) {
			// console.log({ id, status })
			let text = ''

			switch (Number(status)) {
				case 0:
					text = `¿Confirmas regresar a editar la solicitud de la cotización #${id}?`
					break
				case 1:
					text = `¿Confirmas iniciar el proceso de preparación de la cotización #${id}?`
					break
				case 2:
					text = `¿Confirmas que la cotización #${id} ya se encuentra lista para reparto?`
					break
				case 3:
					text = `¿Confirmas que el cliente ha recibido su pedido?`
					break
			}

			Swal.fire({
				title: 'Cotizaciones',
				text,
				showCancelButton: true,
				confirmButtonText: 'Continuar',
				cancelButtonText: 'Cancelar',
				confirmButtonColor: '#41b883',
				cancelButtonColor: '#f5222e',
				reverseButtons: true,
			}).then(async (result) => {
				if (result.isConfirmed) {
					//
					let payload = {
						id: id,
						status,
					}
					if (status == 2) {
						this.modalTitle = 'Cotización para reparto'
						this.impressment_id = id
						this.modalQuotationFiles = true

						return false
					}

					if (status == 3) {
						this.modalTitle = 'Entrega de productos'
						this.impressment_id = id
						this.modalQuotationFiles = true

						return false
					}

					await this.$store.dispatch('impressment/UPDATE_STATUS', payload).then(() => {
						this.initModule()
					})
				}
			})
		},
		setTicket(id) {
			const record = (this.searchText == '' ? this.impressmentList : this.impressmentListFiltered).find((e) => e.id == id)
			if (record) {
				localStorage.setItem('charge_quotation', JSON.stringify(record))
				this.$router.push('/pos')
			}
		},
		searchById() {
			this.$store.commit('impressment/SET_STATE', {
				filters: {
					...this.filters,
					customer_id: '',
					status: '',
					paid: '',
				},
			})
			this.initModule({ current: 1 })
		},
		handleIdChange(e) {
			this.$store.commit('impressment/SET_STATE', {
				filters: {
					...this.filters,
					id: e.target.value,
				},
			})
		},
		getCustomers() {
			let payload = {}
			this.$store.dispatch('customers/GET', payload)
		},
		filterOption(input, option) {
			return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		},
		handleCustomerChange(value) {
			this.$store.commit('impressment/SET_STATE', {
				filters: {
					...this.filters,
					customer_id: value,
					id: '',
				},
			})
			this.initModule({ current: 1 })
		},
		handleStatusChange(value) {
			this.$store.commit('impressment/SET_STATE', {
				filters: {
					...this.filters,
					status: value,
					id: '',
				},
			})
			this.initModule({ current: 1 })
		},
		handlePaidChange(value) {
			this.$store.commit('impressment/SET_STATE', {
				filters: {
					...this.filters,
					paid: value,
					id: '',
				},
			})
			this.initModule({ current: 1 })
		},
		onAddRecord() {
			this.$router.push('/impressment/create')
		},
		initModule(pagination) {
			this.$store
				.dispatch('impressment/GET', {
					id: this.filters.id,
					status: this.filters.status,
					customer_id: this.filters.customer_id,
					paid: this.filters.paid,
					pagination: {
						perPage: this.pagination.pageSize,
						currentPage: utilities.objectValidate(pagination, 'current', this.pagination.current),
					},
				})
				.then((reponse) => {
					// console.log('-->', reponse.resumen)
					this.productSummary = utilities.objectValidate(reponse, 'resumen', [])

					this.pagination = {
						current: utilities.objectValidate(reponse, 'pagination.currentPage', 1),
						pageSize: utilities.objectValidate(reponse, 'pagination.perPage', 10),
						total: utilities.objectValidate(reponse, 'pagination.total', 0),
					}
				})
		},
		onEditRecord(id) {
			this.$router.push(`/impressment/${id}`)
		},
		printQuotation(id) {
			// elegimos el tipo de impresión que necesitamos
			Swal.fire({
				title: 'Selecciona el tipo de impresión',
				input: 'select',
				inputOptions: {
					quote: 'Cotización (con precios)',
					order: 'Pedido (sin precios)',
				},
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'Cancelar',
				inputPlaceholder: 'Selecciona',
				inputValidator: (value) => {
					return new Promise((resolve) => {
						if (!value) {
							resolve('Es necesario elegir una impresión')
						}
						resolve()
					})
				},
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store.dispatch('impressment/GENERATE_PDF', { id, type: result.value }).then((response) => {
						this.quotationBase64 = `data:application/pdf;base64,${response.data.base64}`
						setTimeout(() => {
							this.modalQuotationView = true
						}, 100)
					})
				}
			})
		},
		closeQuotationModal() {
			this.modalQuotationView = false
			this.quotationBase64 = ''
		},
		closeQuotationFilesModal(reloadStatus = false) {
			this.modalQuotationFiles = false
			if (reloadStatus) {
				this.initModule()
			}
		},
		sendQuotation(id, method) {
			Swal.fire({
				title: 'Atención',
				text: `La cotización será enviada al ${method} del cliente/distribuidor. ¿Deseas continuar?`,
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'Cancelar',
			}).then(async (result) => {
				if (result.isConfirmed) {
					let payload = {
						id,
						method,
					}
					await this.$store.dispatch('impressment/SEND_GENERATE_PDF', payload)
					this.initModule()
				}
			})
		},
		onCancelRecord(id) {
			Swal.fire({
				title: 'Atención',
				text: '¿Deseas cancelar la cotización?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No',
			}).then(async (result) => {
				//
				if (result.isConfirmed) {
					await this.$store.dispatch('impressment/DELETE', id)
					this.initModule()
				}
			})
		},
		confirmQuote(id) {
			//
			switch (Number(this.filters.status)) {
				case 5:
					this.modalTitle = 'Autorización un pedido'
					this.impressment_id = id
					break
			}
			this.modalQuotationFiles = true
		},
		closeModal() {
			this.modalView = false
		},
		onSelectChange(selectedRowKeys) {
			this.selectedRowKeys = selectedRowKeys
		},
		onSearch(value) {
			if (value != '') {
				this.impressmentListFiltered = []
				value = value.toLowerCase()
				this.impressmentListFiltered = this.impressmentList.filter((obj) =>
					Object.values(obj).some((val) => {
						if (typeof val == 'string' && val.toLowerCase().includes(value)) {
							return true
						}
					}),
				)
			}
		},
		removeColorFromDescription(description) {
			let baseDesc = description || ''
			// Remover colores comúnes al final de la descripción, separados por espacio, guión o diagonal
			const colorsRegex =
				/((\s+|-|\/)+(rojo|roja|negro|negra|blanco|blanca|azul|amarillo|amarilla|verde|naranja|rosa|rosado|morado|morada|gris|plata|dorado|dorada|caf[eé]|marr[oó]n|tinto|transparente|titanio|bronce|fl[uú]or|mate|brillante|cyan|magenta|multicolor|vino|claro|oscuro|tricolor|bicolor))+$/i

			let cleanedDesc = baseDesc.replace(colorsRegex, '')

			// Límpieza adicional si termina con un guión o diagonal suelto (ej. "Casco -")
			cleanedDesc = cleanedDesc.replace(/[\s/-]+$/, '')

			// Retornamos limpio, si queda vacío (menos probable), regresamos el original
			return cleanedDesc.trim() || baseDesc.trim()
		},
		logProductSummary() {
			this.productSummaryList = [...this.productSummary].sort((a, b) => b.totalQuantity - a.totalQuantity)
			this.totalSummaryItems = this.productSummaryList.reduce((acc, curr) => acc + curr.totalQuantity, 0)

			let grouped = {}
			this.productSummaryList.forEach((item) => {
				let baseDescription = this.removeColorFromDescription(item.description)
				if (!grouped[baseDescription]) {
					grouped[baseDescription] = {
						description: baseDescription,
						totalQuantity: 0,
					}
				}
				grouped[baseDescription].totalQuantity += item.totalQuantity
			})
			this.groupedProductSummaryList = Object.values(grouped).sort((a, b) => b.totalQuantity - a.totalQuantity)

			this.summaryModalView = true
		},
		printSummary() {
			let printContent = `
				<html>
					<head>
						<title>Resumen de Productos</title>
						<style>
							body { font-family: Arial, sans-serif; padding: 20px; }
							table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 12px; }
							th, td { border: 1px solid #ddd; padding: 5px; text-align: left; }
							th { background-color: #f2f2f2; }
							.text-right { text-align: right; }
							h2 { text-align: center; }
						</style>
					</head>
					<body>
						<h2>Resumen de Productos</h2>
						<table>
							<thead>
								<tr>
									<th>SKU</th>
									<th>Descripción</th>
									<th class="text-right">Cantidad</th>
								</tr>
							</thead>
							<tbody>
								${this.productSummaryList
									.map(
										(item) => `
									<tr>
										<td>${item.sku || ''}</td>
										<td>${item.description || ''}</td>
										<td class="text-right">${item.totalQuantity}</td>
									</tr>
								`,
									)
									.join('')}
							</tbody>
						</table>
					</body>
				</html>
			`

			let win = window.open('', '_blank')
			win.document.write(printContent)
			win.document.close()
			setTimeout(() => {
				win.print()
				win.close()
			}, 500)
		},
	},
}
</script>

<style lang="scss">
.tableImpressmentElements {
	td {
		padding-top: 5px !important;
		padding-bottom: 5px !important;
	}
}
</style>